<template>
  <div>
    <div class="current-position">
      <img class="common-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="common-container">
          <div class="current-position-logotext">Member</div>
        </div>
        <div class="common-container">
          当前位置: 首页  >  {{ menu.title }} >  {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
        </div>
      </div>
    </div>
    <!-- <div class="survey-module" v-if="identity=='admin'"> -->
    <div class="survey-module" v-if="false">
      <div class="common-container justify-between">
        <div class="survey-module-left">
          <div class="survey-module-left-action">
            <div class="survey-module-left-title justify-center align-center">{{ menu.title }}</div>
            <div class="survey-module-left-item" 
              v-for="(item,index) in menu.list" 
              :key="index" 
              :class="menu_id==item.id?'survey-module-left-item-select':''"  
              @click="menuFun(item.id)"
            >
              <div class="survey-module-left-child justify-center align-center">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="survey-module-right">
          <div class="survey-module-right-title f-w">
            {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
          </div>
          <zsgl v-if="menu_id==1"/>
          <hygl v-if="menu_id==2"/>
        </div>
      </div>
    </div>
    <div class="survey-module" v-else>
      <div class="common-container justify-between">
        <div class="survey-module-left">
          <div class="survey-module-left-action">
            <div class="survey-module-left-title justify-center align-center">{{ menu.title }}</div>
            <div class="survey-module-left-item" 
              v-for="(item,index) in menu.list" 
              :key="index" 
              :class="menu_id==item.id?'survey-module-left-item-select':''"  
              @click="menuFun(item.id)"
            >
              <div class="survey-module-left-child justify-center align-center">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="survey-module-right">
          <div class="survey-module-right-title f-w">
            {{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}
          </div>
          <!-- 证书查询 or 会员查询 -->
          <div class="survey-module-right-action" :key="menu_id">
            <div class="inquir-form flex-col align-center">
              <span>{{ menu.list[menu.list.findIndex( item => item.id == menu_id)].name }}</span>
              <el-form v-show="!search_show" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" label-position="top">
                <el-form-item prop="name">
                  <div class="inquir-form-label">姓名</div>
                  <input v-model="ruleForm.name" type="text" placeholder="请输入要查询的姓名">
                </el-form-item>
                <el-form-item prop="certificateNumber" v-if="menu_id==1">
                  <div class="inquir-form-label">证书编号</div>
                  <input v-model="ruleForm.certificateNumber" type="text" placeholder="请输入要查询的证书编号">
                </el-form-item>
                <el-form-item prop="memberCode" v-else>
                  <div class="inquir-form-label">证书编码</div>
                  <input v-model="ruleForm.memberCode" type="text" placeholder="请输入要查询的证书编码">
                </el-form-item>
                <!-- <el-form-item prop="name">
                  <div class="inquir-form-label">验证码</div>
                  <div class="inquir-form-code justify-between align-center">
                    <input v-model="ruleForm.name" type="text" placeholder="请输入要查询验证码">
                    <img src="../assets/img/banner.png" alt="">
                  </div>
                </el-form-item> -->
                <el-form-item>
                  <div class="inquir-form-btn justify-center align-center" @click="submitForm('ruleForm')">立即查询</div>
                </el-form-item>
              </el-form>
              <div class="search-box" v-if="search_show">
                <el-form  label-width="auto" v-if="menu_id==1">
                  <el-form-item label="照片">
                    <img class="zhaopian" :src="$baseUrl + search_info.url" alt="">
                  </el-form-item>
                  <el-form-item label="姓名">
                    <span>{{ search_info.name }}</span>
                  </el-form-item>
                  <el-form-item label="身份证号">
                    <span>{{ search_info.identityCard }}</span>
                  </el-form-item>
                  <el-form-item label="性别">
                    <span>{{ search_info.sex }}</span>
                  </el-form-item>
                  <el-form-item label="文化程度">
                    <span>{{ search_info.qualification }}</span>
                  </el-form-item>
                  <el-form-item label="考试级别">
                    <span v-if="search_info.level==2">中级心理咨询师（二级）</span>
                    <span v-if="search_info.level==3">初级心理咨询师（三级）</span>
                    <span v-if="search_info.level==4">助理心理咨询师（四级）</span>
                  </el-form-item>
                  <!-- <el-form-item label="准考证号">
                    <span>{{ search_info.admissionTicket }}</span>
                  </el-form-item> -->
                  <el-form-item label="证书编号">
                    <span>{{ search_info.certificateNumber }}</span>
                  </el-form-item>
                  <el-form-item label="发行时间">
                    <span>{{ search_info.issuanceTime }}</span>
                  </el-form-item>
                  <div class="inquir-form-btn justify-center align-center" style="width: 80%;margin: 0 auto;" @click="search_show = false">返回</div>
                </el-form>
                <el-form label-width="auto" v-if="menu_id==2">
                  <el-form-item label="照片:">
                    <img class="zhaopian" :src="$baseUrl + search_info.picture" alt="">
                  </el-form-item>
                  <el-form-item label="姓名:">
                    <span>{{ search_info.name }}</span>
                  </el-form-item>
                  <el-form-item label="联系电话:">
                    <span>{{ search_info.phone }}</span>
                  </el-form-item>
                  <el-form-item label="性别:">
                    <span>{{ search_info.sex }}</span>
                  </el-form-item>
                  <el-form-item label="出生日期:">
                    <span>{{ search_info.birthDate }}</span>
                  </el-form-item>
                  <el-form-item label="籍贯:">
                    <span>{{ search_info.nativePlace }}</span>
                  </el-form-item>
                  <el-form-item label="专业:">
                    <span>{{ search_info.major }}</span>
                  </el-form-item>
                  <el-form-item label="党派:">
                    <span>{{ search_info.partyAffiliation }}</span>
                  </el-form-item>
                  <el-form-item label="民族:">
                    <span>{{ search_info.nation }}</span>
                  </el-form-item>
                  <el-form-item label="文化程度:">
                    <span>{{ search_info.degreeEducation }}</span>
                  </el-form-item>
                  <el-form-item label="入会时间:">
                    <span>{{ search_info.membershipTime }}</span>
                  </el-form-item>
                  <el-form-item label="到期时间:">
                    <span>{{ search_info.expirationTime }}</span>
                  </el-form-item>
                  <el-form-item label="本会职务:">
                    <span>{{ search_info.duty }}</span>
                  </el-form-item>
                  <el-form-item label="技术职称与级别:">
                    <span>{{ search_info.title }}</span>
                  </el-form-item>
                  <el-form-item label="工作单位及职务:">
                    <span>{{ search_info.workUnit }}</span>
                  </el-form-item>
                  <el-form-item label="学位:">
                    <span>{{ search_info.academicDegree }}</span>
                  </el-form-item>
                  <el-form-item label="通讯处:">
                    <span>{{ search_info.address }}</span>
                  </el-form-item>
                  <el-form-item label="邮编:">
                    <span>{{ search_info.postalCode }}</span>
                  </el-form-item>
                  <el-form-item label="微信:">
                    <span>{{ search_info.wechat }}</span>
                  </el-form-item>
                  <el-form-item label="学历:">
                    <span>{{ search_info.education }}</span>
                  </el-form-item>
                  <el-form-item label-width="100px" label="重要科技发明、著作、学术论文:">
                    <span>{{ search_info.invent }}</span>
                  </el-form-item>
                  <el-form-item label="受过何种奖励:">
                    <span>{{ search_info.reward }}</span>
                  </el-form-item>
                  <el-form-item label="懂何种外语:">
                    <span>{{ search_info.languages }}</span>
                  </el-form-item>
                  <el-form-item label="备注:">
                    <span>{{ search_info.remark }}</span>
                  </el-form-item>
                  <el-form-item label="会员证编码:">
                    <span>{{ search_info.memberCode }}</span>
                  </el-form-item>
                  <div class="inquir-form-btn justify-center align-center" style="width: 80%;margin: 0 auto;" @click="search_show = false">返回</div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <!-- 悬浮查询模块 -->
     <div class="floating-query" v-if="floating_show">
      <div class="floating-query-title justify-between align-center">
        <span>扫描二维码查询证书</span>
      </div>
      <div class="floating-query-action justify-center">
        <img :src="$baseUrl+llll.twoDimensionalCode" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { getList,getCert } from "@/api/hygl";
import hygl from '@/components/hyzx/hygl.vue'
import zsgl from '@/components/hyzx/zsgl.vue'
import { getForm } from "@/api/gwxx";
export default {
  components:{
    hygl,
    zsgl
  },
  data(){
    return{
      loading:false,
      menu:{
        title:'会员中心',
        list:[
          {name:'证书查询',id:'1'},
          {name:'会员查询',id:'2'},
        ]
      },
      menu_id:this.$route.query.id,
      ruleForm: {
        memberCode: '',
        name:'',
        certificateNumber:''
      },
      rules: {
        memberCode: [
            { required: true, message: '请输入证书编码', trigger: 'blur' },
          ],
          certificateNumber: [
            { required: true, message: '请输入证书编号', trigger: 'blur' },
          ],
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
        },
      search_info:{},
      search_show:false,
      identity:localStorage.getItem("identity"),
      floating_show:true,
      llll:{}
    }
  },
  mounted(){
    const jiami = this.$route.query.z;
    if(jiami){
      const jiemiQuery = JSON.parse(decodeURIComponent(window.atob(jiami)));
      for(let key in this.ruleForm){
        this.ruleForm[key] = jiemiQuery[key]
      }
      this.submitForm('ruleForm')
    }
    getForm().then((res)=>{
      this.llll = JSON.parse(res.data)
    })
  },
  methods:{
    menuFun(id){
      this.menu_id = id
      this.search_show = false
    },
    // ------------------------------------会员查询-start
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.menu_id==1){
            this.searchZhengshu()
          }else{
            this.searchHuiji()
          }
        } else {
          return false;
        }
      });
    },
    searchHuiji(){
      getList({pageNum:1,pageSize:1,memberCode:this.ruleForm.memberCode,name:this.ruleForm.name})
        .then(({ data }) => {
          if(data.list.length>0){
            this.$message({type: 'success',message: '查询成功'});
            this.search_info = data.list[0]
            this.search_show = true
          }else{
            this.$message({type: 'error',message: '未查询到相应信息'});
          }
        })
    },
    searchZhengshu(){
      getCert({pageNum:1,pageSize:1,certificateNumber:this.ruleForm.certificateNumber,name:this.ruleForm.name})
        .then(({ data }) => {
          if(data.list.length>0){
            this.$message({type: 'success',message: '查询成功'});
            this.search_info = data.list[0]
            this.search_show = true
          }else{
            this.$message({type: 'error',message: '未查询到相应信息'});
          }
        })
    },
    offSeach(){
      this.search_show = false
      this.search_info = {}
    }
    // ------------------------------------会员查询-end
  }
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
<style>
.table-body .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #8fc930 !important;
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__input.is-focus  .el-checkbox__inner{
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__inner:hover{
  border-color: #8fc930 !important;
}
.table-body .el-button--text {
  color: #8fc930 !important;
}
.table-body .el-button--text:hover {
  color: #72b701 !important;
}
</style>
